import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "IPSC 2006",
  "description": "",
  "published": "2006-05-18T00:00:00.000Z",
  "redirect_from": ["/blog/ipsc-2006/swizec/413"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Nekateri ga mogoce poznate, nekateri morebiti ne, `}<a parentName="p" {...{
        "href": "http://ipsc2006.ksp.sk/index.php"
      }}>{`IPSC`}</a>{` je cudovito tekmovanje skupinskega programiranja oz. resevanja problemov. Za leto 2006 se je odvil danes in sodelovanje je bila precudovita poezija uma, logike in pice. Sodeloval sem ze tretjic, vendar sem prvic cutil, da lahko celo resno pripomorem k resevanju nalog in nisem le nekaksen stroj za proizvodnjo nenavadnih "out of the box" idej za resitve. Ekipa se je uvrstila na 20. mesto visokosolske divizije in na priblizno 110. mesto odprte divizije, kar sicer ne zveni kot veliko, vendar pa pomen, da smo najboljsa ekipa v radiju priblizno 1000km.`}</p>
    <p>{`Pred dnevi sem se tudi zacel ukvarjati s preucevanjem cloveskih poz, predvsem risanja le-teh. Sklenil sem narisati 1000 takih hitrih skic, katerih namen ni nekaj estetsko lepega, ampak pridobivanje obcutka za hitro ujemanje gibanja v nekaj, kar ni videti narejeno, umetno. Ta sposobnost potem v koncni fazi pripomore k bolj verjetnih pozah likov na resnejsih delih.`}</p>
    <p><a parentName="p" {...{
        "href": "http://img462.imageshack.us/my.php?image=kscan01181rb.png"
      }}><img parentName="a" {...{
          "src": "https://img462.imageshack.us/img462/1417/kscan01181rb.th.png",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a><a parentName="p" {...{
        "href": "http://img461.imageshack.us/my.php?image=kscan01170ad.png"
      }}><img parentName="a" {...{
          "src": "https://img461.imageshack.us/img461/6483/kscan01170ad.th.png",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a><a parentName="p" {...{
        "href": "http://img462.imageshack.us/my.php?image=kscan01161di.png"
      }}><img parentName="a" {...{
          "src": "https://img462.imageshack.us/img462/5443/kscan01161di.th.png",
          "alt": "Free Image Hosting at www.ImageShack.us"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      